import { useQuery } from '@tanstack/react-query';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';
import { useTargetUidPayload } from './useTargetUidPayload';

export type BundleStatus =
  | 'draft'
  | 'pending-review'
  | 'in-review'
  | 'twilio-rejected'
  | 'twilio-approved'
  | 'provisionally-approved';

export interface TwilioBundleRow {
  sid: string;
  friendlyName: string;
  status: BundleStatus;
  regulationSid: string | null;
  email: string | null;
  dateCreated: string;
  dateUpdated: string;
  validUntil: string | null;
}

/**
 * Lists Twilio Regulatory-Compliance bundles for the operating user
 * (target user when admin is browsing somebody else's settings).
 */
export function useTwilioBundles(enabled: boolean) {
  const adminPayload = useTargetUidPayload();
  return useQuery<TwilioBundleRow[]>({
    queryKey: ['twilio-bundles', adminPayload.uid ?? null] as const,
    enabled,
    staleTime: 60_000,
    queryFn: async () => {
      const fn = httpsCallable<{ uid?: string }, { items: TwilioBundleRow[] }>(
        functions,
        'listTwilioBundles',
      );
      const r = await fn(adminPayload);
      return r.data.items;
    },
  });
}
